import React from "react";
import "./style.css";

const PriceChangedModal = ({ show, onClose, language }) => {
  if (!show) return null;

  const isEnglish = language === "en";

  return (
    <div className="modal-backdrop">
      <div className="modal-box">
        <h2>⚠️ {isEnglish ? "Price Changed" : "ფასი შეიცვალა"}</h2>
        <p>
          {isEnglish
            ? "The price of the selected product has changed. refresh the page!"
            : "არჩეულ პროდუქტზე ფასი შეიცვალა. გადატვირთეთ გვერდი!"}
        </p>
        <button onClick={onClose}>{isEnglish ? "Close" : "დახურვა"}</button>
      </div>
    </div>
  );
};

export default PriceChangedModal;
